var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { useMemo, useState } from "react";
import { validateExternalUrl, openExternalUrlSafely } from "../utils/url";
export var VideoCallButton = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? "Assistir ao vivo" : _c, url = _a.url;
    var _d = useState(null), feedback = _d[0], setFeedback = _d[1];
    var validation = useMemo(function () { return validateExternalUrl(url); }, [url]);
    var isDisabled = disabled || !validation.isValid;
    var handleClick = function () {
        var opened = openExternalUrlSafely(url);
        if (!opened) {
            setFeedback(validation.message || "Link inválido ou indisponível.");
            return;
        }
        setFeedback(null);
    };
    return (_jsxs("div", __assign({ style: { display: "grid", gap: 8 } }, { children: [_jsxs("button", __assign({ "aria-label": label, disabled: isDisabled, onClick: handleClick, style: {
                    alignItems: "center",
                    background: "linear-gradient(180deg, #0034B7 0%, #001445 100%)",
                    border: "none",
                    borderRadius: 8,
                    boxShadow: "0px 2px 2px 0px #FFFFFF59 inset, 0px 4px 6px 0px #00000040",
                    color: "#FFFFFF",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    fontSize: 14,
                    fontWeight: 600,
                    gap: 8,
                    justifyContent: "center",
                    opacity: isDisabled ? 0.6 : 1,
                    padding: "12px 20px",
                    width: "fit-content",
                }, type: "button" }, { children: [_jsx(VideocamOutlinedIcon, { fontSize: "small" }), label] })), feedback ? (_jsx("span", __assign({ role: "alert", style: { color: "#7A1F1F", fontSize: 12 } }, { children: feedback }))) : null] })));
};
